import * as moment from 'moment';
import { SimpleMapper } from 'src/app/shared/mappers/simple.mapper';
import { ISchedulerSettingsDTO } from '../interfaces/scheduler-settings-dto.interface';
import { ISchedulerSettings } from '../interfaces/scheduler-settings.interface';
import { SchedulerSettings } from '../models/scheduler-settings';

export class SchedulerSettingsMapper extends SimpleMapper<ISchedulerSettings, ISchedulerSettingsDTO> {
    protected toDTOFields: string[] = [
        'turnOnScheduler',
        'checkIntervalSeconds',
        'maxConcurrentProcesses',
        'pauseDuration',
        'maxThreadsCount',
        'maxPRsBunchSizeAllowed',
        'defaultMaxPRsBunchSize',

        'processUseGAPIDataCache',
        'processMaxCacheSizePst',
        'maxCacheSizeMb',
        'processDataTTLSec',
        'processTTLResolutionSec',

        'optimalThreadsPerEc2InstanceCount',
        'threadsIncreaseIntervalMin',
        'threadsIncreaseSchedulerActive',

        'maxProcessThreadTTLMin',
        'processTreadsTTLResolutionSec',
        'isProcessThreadsTTLCheckerActive',

        'garbageCollectorSchedulerIntervalMin',
        'isGarbageCollectorSchedulerActive'
    ];

    toDTO(schedulerSettings: ISchedulerSettings): ISchedulerSettingsDTO {
        const result = super.toDTO(schedulerSettings);

        result.pauseStart = schedulerSettings.pauseStartUTCStr;
        result.pauseEnd = schedulerSettings.pauseEndUTCStr;

        return result;
    }

    fromDTO(schedulerSettingsDTO: ISchedulerSettingsDTO): ISchedulerSettings {
        const schedulerSettingsData: ISchedulerSettings = super.fromDTO(schedulerSettingsDTO);
        if (schedulerSettingsDTO) {
            schedulerSettingsData.pauseStart = schedulerSettingsDTO.pauseStart
                ? moment.utc(schedulerSettingsDTO.pauseStart).local()
                : null;

            schedulerSettingsData.pauseEnd = schedulerSettingsDTO.pauseEnd
                ? moment.utc(schedulerSettingsDTO.pauseEnd).local()
                : null;
        }

        return new SchedulerSettings(schedulerSettingsData);
    }
}
